import { Stack, Box, useMediaQuery, useTheme } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import FormField from './FormField';
import QuestionLabel from './QuestionLabel';
import { fieldSx } from './formTheme';
import { useTranslation } from 'react-i18next';

export default function ActivitiesForm() {
  const { t } = useTranslation();
  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext();

  const theme = useTheme();
  const mobileScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const piercersForPiercersSelection = watch(
    'eventActivities.piercersForPiercers',
  );
  const shibariLectureInterest = watch(
    'eventActivities.shibariLectureInterest',
  );

  const fields = [
    {
      type: 'radio',
      label: t('sauna_consent'),
      name: 'eventActivities.saunaConsent',
      alternateLabel: true,
      options: [
        { label: t('yes'), value: 'TAK' },
        { label: t('no'), value: 'NIE' },
      ],
    },
    {
      type: 'radio',
      label: t('yoga_interest'),
      name: 'eventActivities.yogaInterest',
      alternateLabel: true,
      options: [
        { label: t('yes'), value: 'TAK' },
        { label: t('no'), value: 'NIE' },
      ],
    },
    {
      type: 'radio',
      label: t('hiking_interest'),
      name: 'eventActivities.hikingInterest',
      alternateLabel: true,
      options: [
        { label: t('yes'), value: 'TAK' },
        { label: t('no'), value: 'NIE' },
      ],
    },
    {
      type: 'radio',
      label: t('hook_ritual_interest'),
      name: 'eventActivities.hookRitualInterest',
      alternateLabel: true,
      options: [
        { label: t('yes'), value: 'TAK' },
        { label: t('no'), value: 'NIE' },
      ],
    },
    {
      type: 'radio',
      label: t('play_piercing_interest'),
      name: 'eventActivities.playPiercingInterest',
      alternateLabel: true,
      options: [
        { label: t('yes'), value: 'TAK' },
        { label: t('no'), value: 'NIE' },
      ],
    },
    {
      type: 'radio',
      label: t('piercers_for_piercers'),
      name: 'eventActivities.piercersForPiercers',
      alternateLabel: true,
      options: [
        { label: t('yes'), value: 'TAK' },
        { label: t('no'), value: 'NIE' },
      ],
    },
    {
      type: 'radio',
      label: t('shibari_workshop_interest'),
      name: 'eventActivities.shibariWorkshopInterest',
      alternateLabel: true,
      options: [
        { label: t('yes'), value: 'TAK' },
        { label: t('no'), value: 'NIE' },
      ],
    },
    {
      type: 'select',
      label: t('shibari_skill_level'),
      name: 'eventActivities.shibariSkillLevel',
      alternateLabel: true,
      options: [
        { label: t('beginner'), value: 'Początkujący' },
        { label: t('intermediate'), value: 'Średniozaawansowany' },
        { label: t('advanced'), value: 'Zaawansowany' },
      ],
    },
    {
      type: 'radio',
      label: t('shibari_lecture_interest'),
      name: 'eventActivities.shibariLectureInterest',
      alternateLabel: true,
      options: [
        { label: t('yes'), value: 'TAK' },
        { label: t('no'), value: 'NIE' },
      ],
    },
  ];

  fields.splice(3, 0, {
    type: 'textarea',
    label: t('hiking_alternative'),
    name: 'eventActivities.hikingAlternative',
    alternateLabel: true,
  });

  if (piercersForPiercersSelection === 'TAK') {
    fields.splice(7, 0, {
      type: 'textarea',
      label: '',
      name: 'eventActivities.piercersForPiercersDescription',
      alternateLabel: true,
    });
  }

  if (shibariLectureInterest === 'TAK') {
    fields.splice(11, 0, {
      type: 'text',
      label: '',
      name: 'eventActivities.shibariLectureInterestDesc',
    });
  }

  return (
    <Stack spacing={2}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'flex-end',
          flexWrap: 'wrap',
          gap: 4,
        }}
      >
        {fields.map((field) => (
          <Box key={field.name} sx={fieldSx(field, mobileScreen)}>
            <QuestionLabel
              component='label'
              sx={{ mb: 1, color: 'rgba(255,255,255,0.8)' }}
              collapsible={!(field.alternateLabel || mobileScreen)}
            >
              {field.label}
            </QuestionLabel>
            <FormField
              {...field}
              label={null}
              ariaLabel={
                typeof field.label === 'string' ? field.label : undefined
              }
              register={register}
              error={errors?.eventActivities?.[field.name.split('.')[1]]}
              helperText={
                errors?.eventActivities?.[field.name.split('.')[1]]?.message
              }
              fullWidth
            />
          </Box>
        ))}
      </Box>
    </Stack>
  );
}
